function initQuickViewScripts(scope = document) {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-data');
  const sideCart = document.querySelector('side-cart');

  // ✅ Detect active Shopify currency
  const shopCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}';

  // ✅ Currency formatting function (custom symbols)
  const formatPrice = (cents) => {
    try {
      const v = Number(cents) / 100;
      if (isNaN(v)) return '0.00';

      switch (shopCurrency) {
        case "INR":
          return 'Rs ' + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "USD":
          return '$' + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "DKK":
          return v.toLocaleString("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kr";
        case "AED":
          return 'Dhs ' + v.toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "EUR":
          return '€' + v.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "GBP":
          return '£' + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "CAD":
          return 'CA$' + v.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case "AUD":
          return 'A$' + v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        default:
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: shopCurrency,
          }).format(v);
      }
    } catch (e) {
      const v = Number(cents) / 100;
      if (isNaN(v)) return '0.00';
      return v.toFixed(2) + ' ' + shopCurrency;
    }
  };

  const isVariantAvailable = (product, selectedOptions) => {
    const matchedVariant = product.variants.find(
      v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
    );
    return matchedVariant ? matchedVariant.available : false;
  };

  const updateButtonStates = (product, currentSelectedOptions) => {
    const variantButtons = modalContent.querySelectorAll('.quick-view-form input[type="radio"]');
    variantButtons.forEach(input => {
      const span = input.nextElementSibling;
      const optionIndex = parseInt(input.name.replace('option-', '')) - 1;
      const testOptions = [...currentSelectedOptions];
      testOptions[optionIndex] = input.value;
      const isAvailable = isVariantAvailable(product, testOptions);
      if (isAvailable) {
        span.classList.remove('disabled');
        input.disabled = false;
      } else {
        span.classList.add('disabled');
        input.disabled = true;
      }
    });
  };

  scope.querySelectorAll('.quick-view-btn').forEach(button => {
    button.addEventListener('click', function () {
      const handle = this.getAttribute('data-product-handle');
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          let variantsHTML = '';
          if (product.options.length === 1 && product.options[0].name === 'Title') {
            variantsHTML = `<input type="hidden" name="id" value="${product.variants[0].id}">`;
          } else {
            product.options.forEach((option, optionIndex) => {
              variantsHTML += `
                <div class="variant-option">
                  <div class="variant-option-title">
                    ${option.name}: <span class="selected-value"></span>
                  </div>
                  <div class="variant-buttons">
                    ${[...new Set(product.variants.map(v => v.options[optionIndex]))]
                      .map(
                        value => `
                        <label>
                          <input type="radio" 
                            name="option-${optionIndex + 1}" 
                            value="${value}">
                          <span>${value}</span>
                        </label>
                      `
                      )
                      .join('')}
                  </div>
                </div>
              `;
            });
            variantsHTML += `<input type="hidden" name="id" class="selected-variant-id" value="${product.variants[0].id}">`;
          }

          // let mainSlides = '';
          // let thumbSlides = '';
          // product.images.forEach(img => {
          //   const imgId = img.split('/').pop();
          //   mainSlides += `<div class="swiper-slide"><img src="${img}" alt="${product.title}" data-image-id="${imgId}"></div>`;
          //   thumbSlides += `<div class="swiper-slide"><img src="${img}" alt="${product.title}" data-image-id="${imgId}"></div>`;
          // });

          let mainSlides = '';
          let thumbSlides = '';

          product.media.forEach(media => {
            // Main slider (large view)
            if (media.media_type === 'image') {
              mainSlides += `
                <div class="swiper-slide">
                  <img src="${media.src}" alt="${media.alt || product.title}" data-media-id="${media.id}">
                </div>
              `;
            }

            if (media.media_type === 'video') {
              mainSlides += `
                <div class="swiper-slide" data-media-id="${media.id}">
                  <video controls playsinline muted loop>
                    ${media.sources
                      .map(src => `<source src="${src.url}" type="${src.mime_type}">`)
                      .join('')}
                  </video>
                </div>
              `;
            }

            if (media.media_type === 'external_video') {
              mainSlides += `
                <div class="swiper-slide" data-media-id="${media.id}">
                  ${media.embed}
                </div>
              `;
            }

            if (media.media_type === 'model') {
              mainSlides += `
                <div class="swiper-slide">
                  <model-viewer src="${media.src}" auto-rotate camera-controls data-media-id="${media.id}"></model-viewer>
                </div>
              `;
            }

            // Thumbnail slider
            if (media.preview_image) {
              thumbSlides += `
                <div class="swiper-slide">
                  <img src="${media.preview_image.src}" class="thumbnail-image" data-thumb-media-id="${media.id}">
                </div>
              `;
            } else if (media.media_type === 'image') {
              thumbSlides += `
                <div class="swiper-slide">
                  <img src="${media.src}" class="thumbnail-image" data-thumb-media-id="${media.id}">
                </div>
              `;
            }
          });

          modalContent.innerHTML = `
            <span class="quick-view-close">&times;</span>
            <div class="quick-view-content">
              <div class="quick-view-image">
                <div class="swiper main-slider">
                  <div class="swiper-wrapper">${mainSlides}</div>
                </div>
                <div class="swiper thumbnail-slider">
                  <div class="swiper-wrapper">${thumbSlides}</div>
                </div>
              </div>
              <div class="quick-view-details">
                <h2 class="quick-view-title">${product.title}</h2>
                <div class="quick-view-price-container">
                  <span class="quick-view-price">${formatPrice(product.price)}</span>
                  <span class="quick-view-compare-price" style="text-decoration: line-through; margin-left: 0.5rem; display:none;"></span>
                  <span class="quick-view-discount" style="color:red; margin-left:0.5rem; display:none;"></span>
                </div>
                <div class="quick-view-description">${product.description}</div>
                <form method="post" action="/cart/add" class="quick-view-form product-form">
                  ${variantsHTML}
                  <button type="submit" class="quick-view-add-to-cart-btn add-to-cart-btn">
                    ${product.available ? 'Add to Cart' : 'Sold Out'}
                  </button>
                </form>
              </div>
            </div>
          `;

          modal.style.display = 'flex';

          const thumbSlider = new Swiper('.quick-view-image .thumbnail-slider', {
            spaceBetween: 10,
            slidesPerView: 'auto',
            autoHeight: true,
            mousewheel: true,
          });
          const mainSlider = new Swiper('.quick-view-image .main-slider', {
            spaceBetween: 10,
            autoHeight: true,
            slidesPerView: 'auto',
            thumbs: { swiper: thumbSlider },
          });

          let currentVariant = product.variants[0];

          const updateQuickView = () => {
            let selectedOptions = [];
            modalContent.querySelectorAll('[name^="option-"]:checked').forEach(input => {
              selectedOptions.push(input.value);
              const wrapper = input.closest('.variant-option');
              if (wrapper) wrapper.querySelector('.selected-value').innerText = input.value;
            });

            const matchedVariant = product.variants.find(
              v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
            );
            if (!matchedVariant) return;
            currentVariant = matchedVariant;

            const hiddenInput = modalContent.querySelector('.selected-variant-id');
            if (hiddenInput) hiddenInput.value = currentVariant.id;

            const priceEl = modalContent.querySelector('.quick-view-price');
            const compareEl = modalContent.querySelector('.quick-view-compare-price');
            const discountEl = modalContent.querySelector('.quick-view-discount');

            if (priceEl) priceEl.innerText = formatPrice(currentVariant.price);

            if (compareEl) {
              if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
                compareEl.innerText = formatPrice(currentVariant.compare_at_price);
                compareEl.style.display = 'inline';
                if (discountEl) {
                  const discountPercent = Math.round(((currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price) * 100);
                  discountEl.innerText = `Spar ${discountPercent}%`;
                  discountEl.style.display = 'inline';
                }
              } else {
                compareEl.style.display = 'none';
                if (discountEl) discountEl.style.display = 'none';
              }
            }

            const btn = modalContent.querySelector('.quick-view-add-to-cart-btn');
            if (!currentVariant.available) {
              btn.setAttribute('disabled', '');
              btn.innerText = 'Sold Out';
            } else {
              btn.removeAttribute('disabled');
              btn.innerText = 'Add to Cart';
            }

            // if (currentVariant.featured_image) {
            //   const imgId = currentVariant.featured_image.src.split('/').pop();
            //   const index = Array.from(modalContent.querySelectorAll('.main-slider img')).findIndex(
            //     img => img.dataset.imageId == imgId
            //   );
            //   if (index >= 0) mainSlider.slideTo(index);
            // }

            // Variant → Media slide switching
            if (currentVariant.featured_media) {
              const mediaId = currentVariant.featured_media.id;

              const slides = Array.from(
                modalContent.querySelectorAll('.main-slider [data-media-id]')
              );

              const index = slides.findIndex(slide => slide.dataset.mediaId == mediaId);

              if (index >= 0) {
                mainSlider.slideTo(index);
              }
            }


            updateButtonStates(product, selectedOptions);
          };

          modalContent.querySelectorAll('[name^="option-"]').forEach(input => {
            input.addEventListener('change', updateQuickView);
          });

          modalContent.querySelectorAll('.variant-option').forEach(opt => {
            const firstInput = opt.querySelector('input');
            if (firstInput) firstInput.checked = true;
          });
          if (product.options.length > 1 || product.options[0].name !== 'Title') {
            updateQuickView();
          }

          modalContent.querySelector('.quick-view-form').addEventListener('submit', function (e) {
            e.preventDefault();
            const formData = new FormData(this);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
              body: formData,
            })
              .then(res => res.json())
              .then(() => {
                modal.style.display = 'none';
                if (sideCart && typeof sideCart.getCart === 'function') {
                  sideCart.getCart();
                  if (sideCart.drawer && typeof sideCart.drawer.open === 'function') {
                    sideCart.drawer.open();
                  }
                }
              })
              .catch(err => console.error(err));
          });

          modalContent.querySelector('.quick-view-close').addEventListener('click', () => (modal.style.display = 'none'));
          modal.addEventListener('click', e => {
            if (e.target === modal) modal.style.display = 'none';
          });
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initQuickViewScripts(document);
});